// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"banner_bannerWrapper__a3XBP","banner":"banner_banner__fdxl2"};